<template>
  <div class="material-action" :class="{ 'is-embedded': embedded }">
    <template v-if="!isLoading">
      <header v-if="showHeader">
        <div class="back" @click="handleBack">
          <UIcon name="arrow-left" />
        </div>

        <input type="text" class="title-material" v-model="material.title" placeholder="Введите название материала" />

        <div v-if="!isCreate" class="delete" @click="deleteMaterial">
          <UIcon name="delete" />
        </div>

        <UButton @click="actionMaterial" :loading="isSaving">
          {{ isCreate ? 'Создать материал' : 'Сохранить материал'}}
        </UButton>
      </header>
      
      <div class="content-material-action">
        <div class="description">
          <textarea v-model="material.description" placeholder="Описание материала">
          </textarea>
        </div>
        <UTags v-model="material.tags" />
        <FullText v-model="material.body" />
      </div>
    </template>
    <UPreloader v-else />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { coreApi } from '@/api'
import FullText from '@/components/base/FullText'
import UButton from '@/components/redesign/ui/UButton'
import UPreloader from '@/components/redesign/ui/UPreloader'
import UTags from '@/components/redesign/ui/UTags'

export default {
  name: 'MaterialPage',
  components: {
    UButton,
    UPreloader,
    FullText,
    UTags,
  },
  props: {
    id: {
      type: [String, Number],
      default: 0,
    },
    isPage: {
      type: Boolean,
      default: false,
    },
    embedded: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isLoading: true,
      isSaving: false,
      material: {
        tags: [],
      },
    };
  },
  computed: {
    ...mapState('main', ['user']),
    isCreate() {
      return !(this.id > 0);
    },
    showHeader() {
      return this.isPage || this.embedded;
    },
  },
  methods: {
    async deleteMaterial() {
      await coreApi.articleDelete(this.id);
      this.back();
    },
    handleBack() {
      if (this.embedded && !this.isPage) {
        this.$emit('cancel');
        return;
      }

      this.back();
    },
    back() {
      this.$router.replace(`/materials`);
    },
    async actionMaterial() {
      if (this.isSaving) return;

      this.isSaving = true;

      const params = {
        user: this.user,
        article: {
          ...this.material,
          body: JSON.stringify(this.material.body || []),
          tags: JSON.stringify(this.material?.tags || []),
        },
      };

      try {
        let savedId = this.material.id;

        if (this.material.id) {
          await coreApi.articleUpdate(params);
        } else {
          const createdId = await coreApi.articleCreate(params);
          savedId = createdId?.id || createdId;
          this.material = {
            ...this.material,
            id: savedId,
          };
        }

        await this.refreshArticleStores();

        const savedMaterial = await this.loadSavedMaterial(savedId);
        this.$emit('saved', {
          ...savedMaterial,
          type: 'material',
        });

        if (this.isPage) this.$router.replace(`/materials/`)
      } finally {
        this.isSaving = false;
      }
    },
    async refreshArticleStores() {
      await Promise.all([
        this.$store.dispatch('main/getArticles'),
        this.$store.dispatch('courses/getMaterial'),
      ]);
    },
    async loadSavedMaterial(id) {
      if (id > 0) {
        const material = await coreApi.article({ id });

        if (material?.id) return material;
      }

      return this.material;
    },
    async init() {
      this.isLoading = true;
      if (this.id  > 0) {
        let material = await coreApi.article({ id: this.id });

        if (material) {
          this.material = {
            ...material,
            body: this.parseJsonList(material.body),
            tags: material.tags ? JSON.parse(material.tags) : []
          };
        } else {
          this.back();
        }
      } 

      this.isLoading = false;
    },
    parseJsonList(value) {
      if (Array.isArray(value)) return value;
      if (!value) return [];

      try {
        const parsed = JSON.parse(value);
        return Array.isArray(parsed) ? parsed : [];
      } catch (e) {
        return [];
      }
    },
  },
  async mounted() {
    await this.init();
  },
};
</script>

<style lang="scss">
.material-action {
  width: 100%;

  & > header {
    display: flex;
    align-items: center;
    margin-bottom: 24px;

    .back,
    .delete {
      min-width: 48px;
      width: 48px;
      height: 48px;
      background: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 8px;
      margin-right: 16px;
      cursor: pointer;

      .icon {
        fill: #A9A9A9;
      }

      &:hover {
        .icon {
          fill: #777777;
        }
      }
    }

    .title-material {
      width: 100%;
      height: 48px;
      padding: 0 16px;
      background: #fff;
      border-radius: 8px;
      margin-right: 16px;
      cursor: pointer;
    }

    .button {
      height: 48px;
      max-width: 220px;
    }
  }

  .content-material-action {
    .description {
      margin: 0 auto;
      width: 850px;
      margin-bottom: 16px;
      height: 90px;
      background: #fff;
      cursor: pointer;
      overflow: hidden;
      border-radius: 8px;

      textarea {
        outline: none;
        border-radius: 8px;
        width: 100%;
        height: 90px;
        padding: 16px;
      }
    }

    .full-text-inner {
      max-width: 850px;
      margin: 0 auto;
      background: white;
      border-radius: 8px;
      padding: 16px;
      overflow: inherit;
    }

    .utags {
      margin: 0 auto;
      width: 850px;
      margin-bottom: 16px;
    }
  }

  &.is-embedded {
    padding: 28px 32px 24px;

    & > header {
      min-height: 52px;
      margin-bottom: 28px;
      padding-right: 20px;

      .back {
        background: transparent;
        margin-right: 20px;
      }

      .title-material {
        height: 52px;
        background: transparent;
        border-bottom: 1px solid #E5E7EB;
        border-radius: 0;
        font-weight: 600;
        font-size: 22px;
        line-height: 26px;
        margin-right: 24px;
      }

      .button {
        flex: 0 0 230px;
        max-width: 230px;
        height: 52px;
      }
    }

    .content-material-action {
      display: grid;
      grid-template-columns: minmax(280px, 340px) minmax(0, 1fr);
      gap: 28px;
      align-items: start;

      .description,
      .utags,
      .full-text-inner {
        width: 100%;
        max-width: none;
        margin: 0;
      }

      .description {
        grid-column: 1;
        height: auto;
        min-height: 150px;
        background: #FAFAFA;
        border: 1px solid #E5E7EB;

        textarea {
          height: 150px;
          background: transparent;
          font-size: 15px;
          line-height: 20px;
        }
      }

      .utags {
        grid-column: 1;
        display: block;

        .add-tag {
          width: 100%;
          height: 40px;
          margin-right: 0;
          margin-bottom: 14px;
          padding-bottom: 0;

          input {
            max-width: none;
            width: 100%;
            height: 40px;
            background: #FAFAFA;
            border: 1px solid #E5E7EB;
            border-right: 0;
          }

          .button {
            flex: 0 0 116px;
            height: 40px;
          }
        }

        .list {
          max-width: none;
          min-height: 40px;
          display: flex;
          flex-wrap: wrap;
          gap: 8px;
          padding-bottom: 0;
          overflow: visible;

          .tag {
            margin-right: 0;
          }
        }
      }

      .full-text-inner {
        grid-column: 2;
        grid-row: 1 / span 2;
        min-height: 520px;
        background: #FFFFFF;
        border: 1px solid #E5E7EB;
        border-radius: 8px;
        padding: 18px;
      }
    }

    @media (max-width: 992px) {
      padding: 20px 8px 8px;

      & > header {
        flex-wrap: wrap;
        gap: 12px;

        .title-material {
          order: 2;
          flex-basis: 100%;
          margin-right: 0;
        }

        .button {
          flex: 1 1 190px;
          max-width: none;
        }
      }

      .content-material-action {
        display: flex;
        flex-direction: column;

        .full-text-inner {
          min-height: 420px;
        }
      }
    }
  }
}
</style>
